<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import { onMounted, ref, type Ref } from "vue";
import { ApiRequestError } from "../api/http.js";
import {
  confirmNotificationContactOptIn,
  type NotificationContactOptInResult,
} from "../api/notifications.js";
import AppFooter from "../components/AppFooter.vue";
import ProductMark from "../components/ProductMark.vue";

const result: Ref<NotificationContactOptInResult | null> = ref(null);
const error: Ref<string | null> = ref(null);
const loading: Ref<boolean> = ref(true);

function readToken(): string {
  const parameters: URLSearchParams = new URLSearchParams(
    window.location.hash.replace(/^#/, ""),
  );
  return parameters.get("token") ?? "";
}

function errorText(value: unknown): string {
  return value instanceof ApiRequestError
    ? value.message
    : "The notification opt-in request failed.";
}

onMounted(async (): Promise<void> => {
  try {
    result.value = await confirmNotificationContactOptIn(readToken());
  } catch (value: unknown) {
    error.value = errorText(value);
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <main class="login-page">
    <section class="login-intro">
      <ProductMark />
      <div class="login-intro__content">
        <p class="eyebrow">Notification opt-in</p>
        <h1>Confirm<br /><span>alert emails.</span></h1>
      </div>
    </section>
    <section class="login-panel">
      <div class="login-card">
        <p class="eyebrow">Notification contact</p>
        <h2 v-if="loading">Confirming opt-in…</h2>
        <h2 v-else-if="result">Notifications confirmed</h2>
        <h2 v-else>Opt-in failed</h2>
        <p v-if="result" class="login-card__subtitle">
          {{ result.email }} is now active for tenant notifications.
        </p>
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
      </div>
      <AppFooter />
    </section>
  </main>
</template>
